import { createContext } from 'react';
export var SimulatorContext = /*#__PURE__*/createContext({});